import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { AcuerdoPendienteDetalleComponent } from "./acuerdopendientedetalle.component";


@Component(
    {
        selector: 'acuerdopendiente',
        templateUrl: './acuerdopendiente.component.html',
        styleUrls: ['./acuerdopendiente.component.scss']
    })

export class AcuerdoPendienteComponent implements AfterViewInit{
    consulta!:boolean;
    dataTable: any[];
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string = "";

    SelCiclo: any[] = [];
    SelPeriodoevaluacion: any[] = [];
    SelDepartamento: any[] = [];
    SelPuesto: any[] = [];

    @ViewChild("containerFormulario", {read: ViewContainerRef}) containerFormulario!: ViewContainerRef;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
      this.uriApi = "acuerdopendiente/buscar";
      this.dataTable = [];
      this.GenerarFiltros();
    }

    ngAfterViewInit(){
      this.LoadDatos().then((respuesta : any)=>{
        this.filtrosComponent.SetFiltros(this.filtrosDisplay, true);
      });
    }

    //Genera el filtro para las preguntas
    GenerarFiltros() {
      let filtrosDisplay: Array<FiltroModel> = [];
      filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Periodo evaluacion',
                  DisplayValor: 'descripcion',
                  ValorName: 'periodoevaluacionid',
                  Opciones: this.SelPeriodoevaluacion,
                  Propiedad: "periodoevaluacionid",
                  Obligatorio: true,
                  Buscar: true
              })
      );

      this.filtrosDisplay = filtrosDisplay;
    }

    async LoadDatos(){
      return new Promise((resolve) =>{
          Promise.all([
          this.SelFiltroPeriodoevaluacion()
        ]).then((responses : any) =>{
          return resolve(responses);
        });
      });
    }

    SelFiltroPeriodoevaluacion(){
        return new Promise ((resolve) =>{
                this.appService.Post("planeacion/periodoevaluacion/buscar",{}).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success) {
                        this.SelPeriodoevaluacion = res.data;
                        let filtro = this.filtrosDisplay.find(x => x.ValorName == 'periodoevaluacionid');
                        if(filtro){
                          filtro.Opciones = this.SelPeriodoevaluacion;
                          filtro.Valor = this.SelPeriodoevaluacion[0].periodoevaluacionid;
                        }
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                });

        });
    }

    SetDatos(e:any){
      this.dataTable = e;
    }

    //Formulario para validar que accion se va arealizar y mandar la informacion a la nueva pantalla
    Formulario(accionid: number, entidad:any) {
      let accion: string = ""
      switch (accionid) {
          case 2:
              accion = "Ver";
              break;
      }
      this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
    }

  //Carga el contenedor con la informacion de la nueva pantalla
  cargarContenedorFormulario(data: {accionid: number, accion: string, entidad: any}) {
      this.consulta = true;
      this.containerFormulario.clear();
      const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AcuerdoPendienteDetalleComponent);
      var ref: ComponentRef<any> = this.containerFormulario.createComponent(factory);
      ref.instance.accion = {accionid: data.accionid, accion: data.accion};
      ref.instance.entidad = data.entidad;
      ref.instance.output.subscribe((cambio: boolean) => {
          this.consulta = false;
          ref.destroy();
          if (cambio) {
              this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
          }
      });
  }
}
